module.exports = __webpack_public_path__ + "static/media/question.55d86f62.svg";